<script setup>
import { useAuth } from "@/auth/auth";
import "./button-styles.css"
const { logout } = useAuth();

const handleLogout = () =>
  logout({ redirectPath: "/" });
</script>

<template>
  <button class="auth-button--logout" @click="handleLogout">Log Out</button>
</template>
